import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import store from "../../../../../store";
import { actions } from 'react-redux-form';

import {
    EXTRACT_TEMPLATE_MODULES,
    FILE_NAME_TEMPLATE,
    UPLOAD_TYPES,
    MODAL_CUSTOM_MESSAGE,
    INVENTORY_TEMPLATE,
    DOWNLOAD_TEMPLATE_lABEL,
    INVENTORY_UPLOAD_FILE_LIMITATIONS,
    INVENTORY_UPLOAD_TYPE_MESSAGE,
} from '../../../../../constants/external-constants';

import Translation from '../../../../common/translation/translation.component';
import DragDropUpload from '../../../../common/upload/drag-drop-upload/drag-drop-upload.component';
import { SelectFieldFloatingLabel as Select } from '../../../../common/custom-form/select-filter.component';
import { Loading } from '../../../../common/loading/index';
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import { InventoryUploadAction } from '../../../../../store/external/inventory/inventory-upload/inventory-upload.reducer';
class InventoryUpload extends Component{

    constructor(props) {
        super(props);

        this.childRef = React.createRef();

        this.state = {
            vendor: null,
            extractAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            uploadInProgress: false,
            isLoading: true,
            filterLoading: false,
            loadingLabel: "",
            errorModal: {
                show: false,
                title: "",
                message: ""
            },
        };
    }

    async componentDidMount() {
        const { getInventoryHandlerList, resetInventoryUploadForm } = this.props;

        getInventoryHandlerList().then(() => { this.setState({ isLoading: false }) });
        resetInventoryUploadForm();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];
    
        return translation[locale][key];
        }

    handleChangeVendor = (Id) => {
        this.setState({
            vendor: Id
        });
    }
    onClickDownload = () => {
        if (window.confirm(this.state.extractAlertMsg)) {
           
        }
    }   
    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    dropDragDisable = () => {
        const { inventoryUploadForm } = this.props;
        const requiredField = !inventoryUploadForm.inventoryHandlerId || !inventoryUploadForm.inventoryHandlerUploadTypeId;

        return requiredField;
    }

    handleDownloadTemplate = () => {
        const { downloadInventoryUploadTemplate } = this.props;
        this.setState({
            filterLoading: true,
            loadingLabel: "Downloading"
        })
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            downloadInventoryUploadTemplate().then(() => {
                this.setState({
                    filterLoading: false,
                    loadingLabel: ""
                })
            });
        } else {
            this.setState({
                filterLoading: false,
                loadingLabel: ""
            })
        } 
    }

    handleSuccessProcess = (data) => {
        const { postExecuteProcess, resetInventoryUploadForm } = this.props;
        postExecuteProcess(data.UploadId);
        this.setState({
            uploadInProgress: false
        });
        resetInventoryUploadForm();
    }

    handleAddFiles = () => {
        this.forceUpdate();
    }

    handleRemoveFiles = () => {
        this.forceUpdate();
    }

    djsConfigParams = () => {
        const { inventoryUploadForm } = this.props;

        var baseParams = {
            InventoryHandlerID: inventoryUploadForm.inventoryHandlerId
            , InventoryHandlerUploadTypeID: inventoryUploadForm.inventoryHandlerUploadTypeId
        };

        var djsConfig = {
            params: {
                CreatedBy: sessionStorage.getItem('EID').toString(),
                UserId: sessionStorage.getItem('UserID').toString(),
                UploadTypeId: this.selectedUploadType(),
                ChargeTypeDetails: JSON.stringify({
                    ...baseParams,
                }), 
            },
            maxFiles: INVENTORY_UPLOAD_FILE_LIMITATIONS.maxFiles,
            minFiles: INVENTORY_UPLOAD_FILE_LIMITATIONS.minFiles,
            acceptedFiles: INVENTORY_UPLOAD_FILE_LIMITATIONS.acceptedFiles,
            dictInvalidFileType: this.toLocaleLanguage('error_invalid_file_type'),
            dictMaxFilesExceeded: this.toLocaleLanguage('error_exceeded_maximum_file'),
            dictErrorOccured: this.toLocaleLanguage('error_occured_reupload_file')
        };

        return djsConfig;
    }

    disabledUpload = () => {
        const { inventoryUploadForm } = this.props;
        const requiredField = !(!inventoryUploadForm.inventoryHandlerId && !inventoryUploadForm.inventoryHandlerUploadTypeId);

        let validFiles = false;
        if (this.childRef.current) {
            validFiles = this.childRef.current.checkValidFileForm();
        }

        return !(requiredField && validFiles);
    }

    handleUpload = () => {
        if (this.childRef.current) {
            this.childRef.current.processQueue();
        }
        this.setState({
            uploadInProgress: true
        });
    }

    onErrorUpload = () => {
        this.setState({
            uploadInProgress: false
        })
    }

    handleExtractTemplate = (id) => {

        const { downloadInventoryUploadTemplate } = this.props;

        this.setState({
            filterLoading: true,
            loadingLabel: "Downloading"
        })

        var inventoryTemplate = INVENTORY_TEMPLATE.flatMap(i => i.templates).find(i => i.id === id);

        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            downloadInventoryUploadTemplate(inventoryTemplate.key, inventoryTemplate.fileName)
            this.setState({
                filterLoading: false,
                loadingLabel: ""
            })
        } else {
            this.setState({
                filterLoading: false,
                loadingLabel: ""
            })
        }
    }

    onChangeInventoryHandler(model, value) {
        const { onSelectInventoryHandler } = this.props;

        onSelectInventoryHandler(model, value);
        store.dispatch(actions.reset("inventoryUploadForm.inventoryHandlerUploadTypeId"))  
    }

    selectedUploadType = () => {
        const { inventoryHandlerId, inventoryHandlerUploadTypeId } = this.props.inventoryUploadForm;
        const key = `${inventoryHandlerId}-${inventoryHandlerUploadTypeId}`;

        switch (key) {
            case "1-1":
                return UPLOAD_TYPES.CircuitWireless;
            case "1-2":
                return UPLOAD_TYPES.CircuitEquiment;
            case "1-3":
                return UPLOAD_TYPES.CircuitSim;
            case "1-4":
                return UPLOAD_TYPES.CircuitPlanDetail;
            case "1-5":
                return UPLOAD_TYPES.CircuitCostAllocation;
            case "1-6":
                return UPLOAD_TYPES.CircuitStatus;
            case "2-7":
                return UPLOAD_TYPES.InventoryEquipment;
            default:
                return null;
        }
    }

    render() {
        const { inventoryUploadForm, onInventoryUploadTypeSelect } = this.props;
        const { inventoryHandlerOptions, inventoryHandlerUploadTypeOptions } = this.props.inventoryUpload;

        return (
            <div className="rate-card-upload upload__container">
                {
                    this.state.filterLoading &&
                    <Loading customClass="filter-loading" label={this.state.loadingLabel} />
                }
                <div className="invoice-mapping-container invoice-upload">
                    <div className="field-section">
                        <div className="field-content">

                            <Translation
                                getOnlyText={true}
                                onChangeTranslation={this.onChangeExtractAlertMsg}
                                translationKey={"export_alert_message"} />
                            
                            <div className="spacer" />

                            <div className='items-list'>
                                <Select
                                    className="form-select required"
                                    label={`${this.toLocaleLanguage('inventory_handler')}`}
                                    value={inventoryUploadForm.inventoryHandlerId ?? ""}
                                    options={inventoryHandlerOptions}
                                    onChangeAction={(e,v) => this.onChangeInventoryHandler(e,v)}
                                    fieldProp='inventoryUploadForm.inventoryHandlerId'
                                    requiredField={true}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    optionLabelKey={{
                                        Key: "Key",
                                        Value: "Value"
                                    }}
                                /> 

                                <Select
                                    className="form-select required"
                                    label={`${this.toLocaleLanguage('upload_type')}`}
                                    onChangeAction={(e, v) => onInventoryUploadTypeSelect(e, v)}
                                    value={inventoryUploadForm.inventoryHandlerUploadTypeId ?? ""}
                                    options={inventoryHandlerUploadTypeOptions}
                                    fieldProp='inventoryUploadForm.inventoryHandlerUploadTypeId'
                                    requiredField={true}
                                    placeholder='Select...'
                                    optionLabelKey={{
                                        Key: "Key",
                                        Value: "Value"
                                    }}
                                    disabled={inventoryUploadForm.inventoryHandlerId ? false : true}
                                /> 

                                {this.selectedUploadType() === UPLOAD_TYPES.CircuitWireless && (
                                    <span className="pending-upload-message">
                                        {INVENTORY_UPLOAD_TYPE_MESSAGE.CircuitWireless}
                                    </span>
                                )}
                                {this.selectedUploadType() === UPLOAD_TYPES.CircuitEquiment && (
                                    <span className="pending-upload-message">
                                        {INVENTORY_UPLOAD_TYPE_MESSAGE.CircuitEquiment}
                                    </span>
                                )}
                                {this.selectedUploadType() === UPLOAD_TYPES.CircuitSim && (
                                    <span className="pending-upload-message">
                                        {INVENTORY_UPLOAD_TYPE_MESSAGE.CircuitSim}
                                    </span>
                                )}
                                {this.selectedUploadType() === UPLOAD_TYPES.CircuitPlanDetail && (
                                    <span className="pending-upload-message">
                                        {INVENTORY_UPLOAD_TYPE_MESSAGE.CircuitPlanDetail}
                                    </span>
                                )}
                                {this.selectedUploadType() === UPLOAD_TYPES.CircuitCostAllocation && (
                                    <span className="pending-upload-message">
                                        {INVENTORY_UPLOAD_TYPE_MESSAGE.CircuitCostAllocation}
                                    </span>
                                )}
                                {this.selectedUploadType() === UPLOAD_TYPES.CircuitStatus && (
                                    <span className="pending-upload-message">
                                        {INVENTORY_UPLOAD_TYPE_MESSAGE.CircuitStatus}
                                    </span>
                                )}
                                {this.selectedUploadType() === UPLOAD_TYPES.InventoryEquipment && (
                                    <span className="pending-upload-message">
                                        {INVENTORY_UPLOAD_TYPE_MESSAGE.InventoryEquipment}
                                    </span>
                                )}

                            </div>
                                                     
                            <div className="spacer" />

                        </div>
                    </div>

                    <div className="upload-section">
                        <div className="upload-content">
                            <DragDropUpload
                                ref={this.childRef}                               
                                disabled={this.dropDragDisable()}
                                downloadButton={this.handleDownloadTemplate}
                                djsConfigParams={this.djsConfigParams()}
                                onSuccessProcess={this.handleSuccessProcess}
                                onAddFiles={this.handleAddFiles}
                                onRemoveFiles={this.handleRemoveFiles}
                                uploadTypeId={this.selectedUploadType()}
                                onErrorUpload={this.onErrorUpload}
                                // download template
                                buttonLabel={DOWNLOAD_TEMPLATE_lABEL.inventory_upload}
                                templateList={INVENTORY_TEMPLATE}
                                onSelect={this.handleExtractTemplate}
                                multipleOption={true}
                            />
                        </div>
                    </div>

                    <div className="upload-btn-section">
                        <div className="save-btn-container">
                            <Button disabled={this.disabledUpload() || this.state.uploadInProgress} onClick={this.handleUpload} className="save-details-btn">Upload</Button>
                        </div>
                    </div>

                </div>
            </div>

        );
    }

}
   

export default connect(
    state => {
        const { translation, inventoryUpload } = state;
        const { inventoryUploadForm } = state.form;
       
        return {
            ...translation
            , inventoryUpload
            , inventoryUploadForm
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, InventoryUploadAction),
        dispatch
    )
)(InventoryUpload);